<script setup lang="ts">
import {ref} from "vue";
import ProxyProperties from "~/components/hero/ProxyProperties.vue";

const { t } = useI18n();
const isVisible = ref(false);
</script>

<template>
  <section class="sx-stats" :class="{ visible: isVisible }">
    <h2 class="sx-landing-title sx-stats__title">
      {{ $t('pages.home.stats.title') }}
    </h2>
    <div class="sx-stats__content">
      <p class="sx-stats__description">
        {{ $t('pages.home.stats.description') }}
      </p>
      <proxy-properties />
    </div>
  </section>
</template>

<style lang="scss" scoped>
.sx-stats {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  gap: 16px;
  z-index: 2;
  background: #fff;
  padding-inline: 2rem;
  margin-bottom: 4rem;

  @media (height <= 1200px) {
    justify-content: flex-end;
    background: transparent;
  }

  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5.25rem;
  }
  &__title {
    font-size: 60px;
    line-height: 60px;
    letter-spacing: -0.03em;
    z-index: 10;
    color: var(--font-sx-color-semiblack);

    &.white {
      color: white;
    }

    @media(width < 1440px) {
      font-size: narrow(60, 24) !important;
      line-height: narrow(60, 32) !important;
    }

    @media(width < 780px) {
      text-align: center;
    }
  }

  &__description {
    max-width: 870px;
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    text-align: center;
    height: 48px;
  }
}
</style>
